import { REQUEST_STATUS } from '@src/constants/voice';

export const isTerminalRequestStatus = (status) =>
  status === REQUEST_STATUS.SUCCESS || status === REQUEST_STATUS.FAILURE;

// The backend can emit an IN_PROGRESS notification after the SUCCESS one
// for the same request. Applying it would roll a finished request back.
export const isStatusRegression = (prevStatus, nextStatus) =>
  isTerminalRequestStatus(prevStatus) &&
  nextStatus === REQUEST_STATUS.IN_PROGRESS;
